import { lazy } from 'react'

const MajorsComponent = lazy(async () => {
  const { Majors } = await import(/* webpackChunkName: "majors" */ './index')

  return {
    default: Majors
  }
})
const routes = [
  {
    path: '/majors',
    render(props) {
      return <MajorsComponent {...props} />
    }
  },
  {
    path: '/education',
    render(props) {
      return <MajorsComponent {...props} />
    }
  }
]

export { routes }
